import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { InternalRoutes } from '../enum/InternalRoutes';

interface IRegistrationTypeModalProps {
    show: boolean;
    closeModal: () => void;
}

export function RegistrationTypeModal({ show, closeModal }: IRegistrationTypeModalProps) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const handleNavigate = (route: string) => {
        navigate(route);
        closeModal();
    };

    return (
        <Modal keyboard={false} size="xl" centered show={show} onHide={() => closeModal()}>
            <Modal.Header closeButton />
            <Modal.Body>
                <div className="register-page">
                    <div className="register_header">
                        <span className="register_subtitle text-uppercase">{t('auth.register.get_started')}</span>
                        <h2>{t('auth.register.title')}</h2>
                        <p className="register_description">{t('auth.register.desc')}</p>
                    </div>

                    <div className="register_cards">
                        <div className="card">
                            <img src="/icons/registration/img-brand.png" alt="Advertiser" className="card_image" />
                            <div className="card_content">
                                <h4>{t('auth.register.cards.advertiser')}</h4>
                                <p className="card_text">{t('auth.register.cards.advertiser_desc')}</p>
                                <hr className="border-secondary" />
                                <ul className="card_list">
                                    <li>
                                        {t('auth.register.cards.advertiser_find_new_influencers_with_our_discovery')}
                                    </li>
                                    <li>
                                        {t(
                                            'auth.register.cards.advertiser_book_them_fast_and_easily_with_our_digital_contracts'
                                        )}
                                    </li>
                                    <li>{t('auth.register.cards.advertiser_manage_all_postings_in_one_calendar')}</li>
                                    <li>
                                        {t(
                                            'auth.register.cards.advertiser_complete_reporting_thanks_to_our_ai_verification'
                                        )}
                                    </li>
                                </ul>
                                <Button
                                    className="card_button"
                                    onClick={() =>
                                        (window.location.href = 'https://www.influencevision.com/en/book-a-demo/')
                                    }
                                    variant="primary"
                                >
                                    {t('auth.register.cards.advertiser_btn')}
                                </Button>
                            </div>
                        </div>

                        <div className="card">
                            <img
                                src="/icons/registration/img-ceator.png"
                                alt="Content Creator"
                                className="card_image"
                            />
                            <div className="card_content">
                                <h4>{t('auth.register.cards.content_creator')}</h4>
                                <p className="card_text">{t('auth.register.cards.content_creator_desc')}</p>
                                <hr className="border-secondary" />
                                <ul className="card_list">
                                    <li>
                                        {t(
                                            'auth.register.cards.content_creator_match_with_brands_like_samsung_dyson_c_a_and_more'
                                        )}
                                    </li>
                                    <li>
                                        {t(
                                            'auth.register.cards.content_creator_content_approval_made_easy_through_our_mobile_app'
                                        )}
                                    </li>
                                    <li>
                                        {t(
                                            'auth.register.cards.content_creator_no_more_writing_down_kpis_with_our_ai_reporting_verification'
                                        )}
                                    </li>
                                    <li>{t('auth.register.cards.content_creator_no_fees')}</li>
                                </ul>
                                <Button
                                    className="card_button"
                                    onClick={() => handleNavigate(`${InternalRoutes.INFLUENCER_REGISTRATION}/1`)}
                                    variant="warning"
                                >
                                    {t('auth.register.cards.content_creator_btn')}
                                </Button>
                            </div>
                        </div>

                        <div className="card">
                            <img
                                src="/icons/registration/img-agency.png"
                                alt="Creator Management"
                                className="card_image"
                            />
                            <div className="card_content">
                                <h4>{t('auth.register.cards.creator_management')}</h4>
                                <p className="card_text">{t('auth.register.cards.creator_management_desc')}</p>
                                <hr className="border-secondary" />
                                <ul className="card_list">
                                    <li>
                                        {t(
                                            'auth.register.cards.creator_management_unlimited_creator_and_manager_additions'
                                        )}
                                    </li>
                                    <li>
                                        {t(
                                            'auth.register.cards.creator_management_finding_and_negotiating_deals_in_one_simple_interface'
                                        )}
                                    </li>
                                    <li>
                                        {t(
                                            'auth.register.cards.creator_management_collaborate_with_your_creators_easily'
                                        )}
                                    </li>
                                    <li>{t('auth.register.cards.creator_management_no_fees')}</li>
                                </ul>
                                <Button
                                    className="card_button"
                                    onClick={() =>
                                        (window.location.href = String(process.env.VITE_ONBOARDING_CALENDLY))
                                    }
                                    variant="info"
                                >
                                    {t('auth.register.cards.creator_management_btn')}
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <div className="d-flex justify-content-center w-100">
                    <p className="text-muted">{t('auth.already_have_profile')} </p>
                    <h6 className="cursor-pointer ml-1" onClick={closeModal}>
                        {t('auth.signin')}
                    </h6>
                </div>
            </Modal.Footer>
        </Modal>
    );
}
